import getStyled from "../../../hooks/getStyled";
import { Card } from "@mui/material";
import { ConnectionLineType } from "reactflow";

const { styled } = getStyled();

export const CARD_WIDTH = 260;

export const FLOW_CHART_NODE_TYPES = {
  QUESTION: "question",
  ANSWER: "answer",
  CHAT: "chat",
  BUTTON: "button",
  CUSTOM: "custom",
};

export const FLOW_CHART_DEFAULTS = {
  NODE_WIDTH: 260, // CARD_WIDTH
  NODE_HEIGHT: 64, // CARD_HEIGHT
  EDGE_BORDER_RADIUS: 40, // EDGE_BORDER_RADIUS
  EDGE_LINE_TYPE: ConnectionLineType.SmoothStep,
};

export const StyledCard = styled(Card, { shouldForwardProp: false })(
  ({ theme, hasError, disabled }) => ({
    width: CARD_WIDTH,
    border: `2px solid ${theme.palette.grey200.main}`,
    borderRadius: 4,
    "& .MuiCardHeader-action": {
      alignSelf: "center",
    },
    "& .MuiTypography-body2": {
      wordBreak: "break-all",
    },
    ...(hasError &&
      !disabled && {
      borderTop: `4px solid ${theme.palette.red400.main}`,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      "& .MuiTypography-body2": {
        color: theme.palette.red400.main,
      },
    }),
    ...(disabled && {
      backgroundColor: theme.palette.grey50.main,
    }),
    "& .MuiTypography-body2 p": {
      margin: "0 !important",
    },
  })
);
